import { render } from "./QuizStep1Widget.vue?vue&type=template&id=3f793c50"
import script from "./QuizStep1Widget.vue?vue&type=script&lang=js"
export * from "./QuizStep1Widget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__